import gql from 'graphql-tag';

/** 售后 */
export const AFTER_SALE_FRAGMENT = gql`
  fragment AfterSale on AfterSale {
    id
    createdAt
    updatedAt
    type
    mode
    cause
    description
    img
    price
    code
    auditTimeout
    logisticsTimeout
    merchantConfirmReceiptTimeout
    userConfirmReceiptTimeout
    userHandleTimeout
    state
    groundsRefusal
    reclaimedShoppingCredits
    returnedShoppingCredits
    afterSaleLines {
      id
      price
      quantity
      orderLine {
        id
        quantity
        totalQuantity
        unitPrice
        featuredAsset {
          source
        }
        productVariant {
          id
          price
          name
          options {
            code
            name
          }
          featuredAsset {
            source
          }
          product {
            id
            name
            featuredAsset {
              source
            }
            customFields {
              price
              markingPrice
            }
          }
        }
      }
    }
    logisticses {
      id
      logisticCode
      company
      type
      state
      logisticInfo {
        logisticCode
        shipperCode
        traces {
          acceptStation
          acceptTime
        }
        state
      }
    }
    afterSaleHistories {
      id
      createdAt
      type
      operatorType
      message
      data {
        type
        mode
        cause
        description
        img
        price
        code
        state
        groundsRefusal
        reclaimedShoppingCredits
        returnedShoppingCredits
      }
    }
    order {
      id
      customFields {
        isAvailableAfterSale
      }
      state
      orderPlacedAt
    }
    channelAddress {
      fullName
      company
      streetLine1
      streetLine2
      city
      province
      postalCode
      phoneNumber
      district
    }
  }
`;
